<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="vertical-center-box">
      <el-select v-model="fileInfoType" style="width: 150px" @change="onFileInfoTypeChange">
        <el-option v-for="type in fileInfoTypes" :key="type.value" :label="type.label" :value="type.value"></el-option>
      </el-select>
      <el-button class="mr-l4" :disabled="disableDeleteButton" @click="onDeleteButtonClick">삭제</el-button>
    </div>
    <div class="vertical-center-box">
      <span class="mr-r10">최근 수집시간 : <em>{{updateDatetime}}</em></span>
      <el-button class="mr-r4" size="small" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="onShowHeadSearchButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <!-- 대용량 파일 생성 정보 -->
  <el-table-wrapper v-show="fileInfoType === 'bulkFileCreation'" ref="bulkFileCreationTable" v-loading="bulkFileCreation.loading"
  :data="bulkFileCreation.tableData" :columns="bulkFileCreation.columns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="bulkFileCreation.showSearchTool"
  :total="bulkFileCreation.total" remote @condition-change="loadBulkFileCreation" @selection-change="onBulkFileCreationTableSelectionChange"/>
  <!-- 파일 변경 이력 -->
  <el-table-wrapper v-show="fileInfoType !== 'bulkFileCreation'" ref="fileAuditTable" v-loading="fileAudit.loading"
  :data="fileAudit.tableData" :columns="fileAudit.columns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="fileAudit.showSearchTool"
  :total="fileAudit.total" remote @condition-change="loadFileAuditHist" @selection-change="onFileAuditTableSelectionChange"/>


  <!-- 파일 접근 이력 02.07 숨김 처리 -->
  <!-- 윈도우 서버는 파일접근이력 제공하지 않으므로 -->
  <!-- <div v-if="nodeParams.objtypeId === 'WINSVR'" class="title-h3">대용량 파일 생성 목록</div> -->
  <!-- <el-radio-group v-show="fileInfoType === 'fileAccess'" v-model="accessType" class="mr-l15" @change="loadData">
    <el-radio label="CP">파일복사</el-radio>
    <el-radio label="MV">파일이동</el-radio>
    <el-radio label="OP">파일접근</el-radio>
    <el-radio label="RM">파일삭제</el-radio>
  </el-radio-group>
  파일 접근 이력 선택시
  <el-date-picker v-show="fileInfoType === 'fileAccess'" style="width: 250px" v-model="dateRange" type="daterange" @change="loadData"
  align="right" unlink-panels size="small" class="mr-r4" :range-separator="defaultDateRangeOptions.rangeSeparator" :picker-options="defaultDateRangeOptions.pickerOptions"
  :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :default-time="defaultDateRangeOptions.defaultTime"></el-date-picker>
  <el-table-wrapper v-show="fileInfoType === 'fileAccess'" v-loading="isLoading" ref="fileAccessTable" :data="tableData" :columns="fileAccessColumns"
  :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" @condition-change="loadFileAccessHist"
  :total="total" remote /> -->
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil } from 'lodash';
import moment from 'moment';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import { convertValuByUnit } from '@/utils/number';
import msgUtil from '@/utils/message';
import serverInfoAPI from '@/api/config/server/server-info';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const FILE_INFO_TYPE_BULK_FILE = 'bulkFileCreation';
const FILE_INFO_TYPE_FILE_AUDIT = 'fileAudit';

export default {
  name: 'WFileInfoNode',
  props: {
    active: {
      type: Boolean,
    },
  },
  data() {
    // const now = new Date();
    // const startDatetime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    // const endDatetime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    return {
      columnDefault,
      defaultDateRangeOptions,
      fileInfoType: FILE_INFO_TYPE_BULK_FILE,
      fileInfoTypes: [
        { label: '대용량 파일 생성 정보', value: FILE_INFO_TYPE_BULK_FILE },
        { label: '파일 변경 정보', value: FILE_INFO_TYPE_FILE_AUDIT },
      ],
      showSearchTool: false,
      // 대용량 파일 생성 정보
      bulkFileCreation: {
        loading: false,
        showSearchTool: false,
        tableData: [],
        updateDatetime: null,
        total: 0,
        selection: [],
        columns: [
          {
            type: 'selection',
          },
          // 2019.02.11 Agent/BE #49253건 처리 완료 전 까지 임시로 사용자/IP 주소 컬럼 제거
          // {
          //   prop: 'userName',
          //   label: '사용자',
          //   width: 150,
          //   sortable: true,
          //   searchable: true,
          //   remoteProp: 'user_name',
          //   formatter: defaultFormatter,
          // },
          // {
          //   prop: 'ipaddress',
          //   label: 'IP 주소',
          //   width: 150,
          //   sortable: true,
          //   searchable: true,
          //   formatter: defaultFormatter,
          // },
          {
            prop: 'generatedFileName',
            label: '생성된 파일명',
            sortable: true,
            searchable: true,
            remoteProp: 'generated_file_name',
            formatter: defaultFormatter,
          },
          {
            prop: 'generatedFileSize',
            label: '파일 크기',
            width: 200,
            sortable: true,
            remoteProp: 'generated_file_size',
            formatter: (row, column, value) => convertValuByUnit(value, 'Byte', true, true, true),
          },
          {
            prop: 'generatedTime',
            label: '생성 시각',
            width: 150,
            sortable: true,
            searchable: true,
            searchType: 'date',
            remoteProp: 'generated_time',
            formatter: this.getDateFormatter,
          },
        ],
      },
      // 파일 변경 이력
      fileAudit: {
        loading: false,
        showSearchTool: false,
        tableData: [],
        updateDatetime: EMPTY_TEXT,
        total: 0,
        selection: [],
        columns: [
          {
            type: 'selection',
          },
          // 2019.02.11 Agent/BE #49253건 처리 완료 전 까지 임시로 사용자/IP 주소 컬럼 제거
          // {
          //   prop: 'userName',
          //   label: '사용자',
          //   width: 150,
          //   sortable: true,
          //   searchable: true,
          //   remoteProp: 'user_name',
          //   formatter: defaultFormatter,
          // },
          // {
          //   prop: 'ipaddress',
          //   label: 'IP 주소',
          //   width: 150,
          //   sortable: true,
          //   searchable: true,
          //   formatter: defaultFormatter,
          // },
          {
            prop: 'notChgedFileName',
            label: '변경 파일명',
            sortable: true,
            searchable: true,
            remoteProp: 'not_chged_file_name',
            formatter: defaultFormatter,
          },
          {
            prop: 'lastModifiedTime',
            label: '마지막 변경 시각',
            width: 150,
            sortable: true,
            searchable: true,
            searchType: 'date',
            remoteProp: 'last_modified_time',
            formatter: this.getDateFormatter,
          },
          {
            prop: 'checkDatetime',
            label: '확인 시각',
            width: 150,
            sortable: true,
            searchable: true,
            searchType: 'date',
            remoteProp: 'check_datetime',
            formatter: this.getDateFormatter,
          },
        ],
      },
      // dateRange: [startDatetime, endDatetime],
      // accessType: 'CP',
      // fileAccessColumns: [
      //   {
      //     prop: 'srcFile',
      //     label: '원본 파일',
      //     sortable: true,
      //     searchable: true,
      //     formatter: defaultFormatter,
      //   },
      //   {
      //     prop: 'dstFile',
      //     label: '대상 파일',
      //     sortable: true,
      //     searchable: true,
      //     formatter: defaultFormatter,
      //   },
      //   {
      //     prop: 'userName',
      //     label: '사용자명',
      //     width: 150,
      //     sortable: true,
      //     searchable: true,
      //     formatter: defaultFormatter,
      //   },
      //   {
      //     prop: 'ipaddress',
      //     label: '사용자 IP 주소',
      //     width: 200,
      //     sortable: true,
      //     searchable: true,
      //     formatter: defaultFormatter,
      //   },
      //   {
      //     prop: 'checkDatetime',
      //     label: '작업 시각',
      //     width: 150,
      //     sortable: true,
      //     searchable: true,
      //     searchType: 'date',
      //     formatter: dateFormatter,
      //   },
      // ],
    };
  },
  computed: {
    /**
     * 삭제 버튼 비활성화 여부
     * @author Ju
     * @return {[type]} [description]
     */
    disableDeleteButton() {
      return this.fileInfoType === FILE_INFO_TYPE_BULK_FILE ? this.bulkFileCreation.selection.length <= 0 : this.fileAudit.selection.length <= 0;
    },
    /**
     * 데이터 최근 수집 시각
     * @author Ju
     * @return {[type]} [description]
     */
    updateDatetime() {
      const checkDatetime = this.fileInfoType === FILE_INFO_TYPE_BULK_FILE ? this.bulkFileCreation.updateDatetime : this.fileAudit.updateDatetime;
      return (isNil(checkDatetime) || checkDatetime === EMPTY_TEXT) ? EMPTY_TEXT : moment(new Date(checkDatetime)).format('YYYY-MM-DD HH:mm:ss');
    },
    ...mapGetters(['selectedNode']),
  },
  methods: {
    /**
     * 파일 정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.fileInfoType === FILE_INFO_TYPE_BULK_FILE) {
        this.loadBulkFileCreation();
      } else {
        this.loadFileAuditHist();
      }
    },
    /**
     * 대용량 파일 생성 목록 데이터 조회
     * @author jeee12
     */
    loadBulkFileCreation() {
      const tableParams = this.$refs.bulkFileCreationTable.getParameter();
      const params = {
        ...tableParams,
        objId: this.selectedNode.obj.objId,
      };
      this.bulkFileCreation.loading = true;
      serverInfoAPI.getBulkFileCreationList(params).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (isNil(data)) {
            this.bulkFileCreation.tableData = [];
            this.bulkFileCreation.updateDatetime = null;
          } else {
            this.bulkFileCreation.tableData = data.data;
            this.bulkFileCreation.updateDatetime = data.checkDatetime;
          }
          this.bulkFileCreation.total = response.data.total;
          this.bulkFileCreation.selection = [];
        } else {
          this.failToLoadBulkFileCreation();
        }
      }).catch(() => {
        this.failToLoadBulkFileCreation();
      }).finally(() => {
        this.bulkFileCreation.loading = false;
      });
    },
    /**
     * 대용량 파일 생성 정보 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadBulkFileCreation() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '대용량 파일 생성 정보', false));
    },
    /**
     * 파일 변경 이력을 로드한다.
     * @author Ju
     * @re
     * turn {[type]} [description]
     */
    loadFileAuditHist() {
      const tableParams = this.$refs.fileAuditTable.getParameter();
      const params = {
        ...tableParams,
        objId: this.selectedNode.obj.objId,
      };
      this.fileAudit.loading = true;
      serverInfoAPI.getFileAuditHist(params).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (isNil(data)) {
            this.fileAudit.tableData = [];
            this.fileAudit.updateDatetime = null;
          } else {
            this.fileAudit.tableData = data.data;
            this.fileAudit.updateDatetime = data.checkDatetime;
          }
          this.fileAudit.total = response.data.total;
          this.fileAudit.selection = [];
        } else {
          this.failToLoadFileAuthHist();
        }
      }).catch(() => {
        this.failToLoadFileAuthHist();
      }).finally(() => {
        this.fileAudit.loading = false;
      });
    },
    /**
     * 파일 변경 이력 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadFileAuthHist() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '파일 변경 정보', false));
    },
    /**
     * 파일 정보 타입 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onFileInfoTypeChange() {
      this.loadData();
    },
    /**
     * 대용량 파일 생성 정보 테이블 selection change 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onBulkFileCreationTableSelectionChange(selection) {
      this.bulkFileCreation.selection = selection;
    },
    /**
     * 대용량 파일 생성 정보 테이블 selection change 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onFileAuditTableSelectionChange(selection) {
      this.fileAudit.selection = selection;
    },
    /**
     * 헤더 검색 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onShowHeadSearchButtonClick() {
      if (this.fileInfoType === FILE_INFO_TYPE_BULK_FILE) {
        this.bulkFileCreation.showSearchTool = !this.bulkFileCreation.showSearchTool;
      } else {
        this.fileAudit.showSearchTool = !this.fileAudit.showSearchTool;
      }
    },
    /**
     * 엑셀 출력 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    exportExcel() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.fileInfoType === FILE_INFO_TYPE_BULK_FILE) {
        serverInfoAPI.exportBulkFileCreationList(params).catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀 파일', false));
        });
      } else {
        serverInfoAPI.exportFileAuthHistExcel(params).catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀 파일', false));
        });
      }
    },
    /**
     * 삭제 버튼 클릭 이벤트 핸들러
     * @return {[type]} [description]
     */
    onDeleteButtonClick() {
      if (this.fileInfoType === FILE_INFO_TYPE_BULK_FILE) {
        this.deleteBulkFileCreation();
      } else {
        this.deleteFileAuditHist();
      }
    },
    /**
     * 대용량 파일 생성 정보를 삭제한다.
     * @return {[type]} [description]
     */
    deleteBulkFileCreation() {
      const target = '대용량 파일 생성 정보';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        serverInfoAPI.deleteServerDirAudit(this.bulkFileCreation.selection).then((response) => {
          const isSuccess = response.data.success;
          this.$message(msgUtil.getResultMsgData(action, target, isSuccess));
          if (isSuccess) {
            this.loadBulkFileCreation();
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    /**
     * 파일 변경 이력을 삭제한다.
     * @return {[type]} [description]
     */
    deleteFileAuditHist() {
      const target = '피일 변경 정보';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        serverInfoAPI.deleteFileAuditHist(this.fileAudit.selection).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadFileAuditHist();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    /**
     * 파일 접근 이력 데이터 조회
     * @author jeee12
     * @return {[type]} [description]
     */
    // loadFileAccessHist() {
    //   const tableParams = this.$refs.fileAccessTable.getParameter();
    //   const params = {
    //     ...tableParams,
    //     serverId: this.nodeParams.serverId,
    //     objId: this.nodeParams.objId,
    //     fileAccessType: this.accessType,
    //   };
    //   if (isNil(tableParams.searchParams) && isNil(tableParams.dateSearchParams) && !isNil(this.dateRange)) {
    //     // 헤더검색은 기준이 되는 '시각' 정보 제외하고 제공
    //     params.startDatetime = this.dateRange[0];
    //     params.endDatetime = this.dateRange[1];
    //   }
    //   serverInfoAPI.getFileAccessList(params).then((response) => {
    //     if (response.data.success) {
    //       this.tableData = response.data.data;
    //       this.total = response.data.total;
    //     }
    //   });
    // },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/operation/server/components/FileInfoComponent.vue